import { useStaticRoomById } from '@features/rooms';
import { toStaticRoom } from './mappers';

export default function useStaticRoom(roomId: string, language?: string) {
  const {
    data,
    isFetching: isFetchingStaticRoom,
    error: staticRoomError,
  } = useStaticRoomById(roomId, language);

  const staticRoom = data
    ? toStaticRoom(data)
    : {
        title: '',
        description: '',
        images: [],
        maxOccupancy: 0,
        amenities: [],
        roomId,
        imageUrl: '',
        additionalImages: [],
        beds: {
          total: 0,
          types: null,
        },
        maxAdults: null,
        maxChildren: null,
        minAdults: null,
        minChildren: null,
      };

  return {
    staticRoom,
    isFetchingStaticRoom,
    staticRoomError,
  };
}
